<template>
  <draggable class="dragArea"
    v-if="renderComponent"
    v-bind="dragOptions"
    tag="div" :list="items" :group="{ name: 'g1'}" :disabled="disabled" @clone="checkMove($event)"

      @start="onStart($event)"
      @end="onEnd($event)">
      <transition-group type="transition" name="flip-list">
        <div v-for="(item, index) in items" :key="item.id" :class="item.restaurant ? 'restaurant' : ''" :data-item-uuid="item.uuid">
          <div class="single--activity-list-item" :class="{'is-disabled' : (!item.active || !parentActive)}">
            <section class="move">
              <i class="fal fa-ellipsis-v"></i>
              <i class="fal fa-ellipsis-v"></i>
            </section>
            <i class="fas fa-triangle" :class="{'is--open' : isOpenState(item)}"
              @click = "toggleOpenState(item, index)"
              v-if="item.children.length && itemCanHaveChildren(item)"></i>
            <span class="truncated">{{item.title[defaultLanguage.code]}}</span>
             <span class="badge badge-trial" v-if="item.restaurant">Servizio:&nbsp;<strong>{{ item.restaurant.name }}</strong></span> <span class="badge badge-trial" v-if="!itemCanHaveChildren(item)">Link</span>
            <section class="options">
              <span v-if="item.uuid === lastEditedUuid" class="latest">
                <i class="fas fa-circle latest-bulb"></i>
              </span>
              <a href="#" @click.prevent="openCreationFormNested(item.id)" v-if="itemCanHaveChildren(item)">
                <i class="fas fa-plus-circle"></i>
              </a>
              <a href="#" @click.prevent @click="toggleActiveItemAtIndex(index, item.id)">
                <i :class="`fas fa-eye${ !item.active ? '-slash' : '' }`"></i>
              </a>
              <a href="#" @click.prevent="setCurrentEditableItem(item)" class="btn btn-white">Modifica</a>
            </section>
          </div>
          <NestedActivityContent :items="item.children" :defaultLanguage="defaultLanguage" :parentActive="item.active && parentActive" :parentItem="item"
            v-if="(
              (itemCanHaveChildren(item) && isOpenState(item)) || (dragging && item.children.length === 0))
            " :disabled="blockNest" :lastEditedUuid="lastEditedUuid"/>
        </div>
      </transition-group>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable'
import EventBus from './EventBus'
export default {
  props: {
    defaultLanguage: {
      required: true,
      type: Object
    },
    items: {
      required: false,
      type: Array
    },
    parentActive: {
      required: false,
      default: true
    },

    lastEditedUuid: {
      required: false,
      default: null
    },

    disabled: {
      required: false,
      default: false
    },

    parentItem: {
      required: false,
      type: Object
    }
  },

  data () {
    return {
        renderComponent: true,
        dragging: false,
        blockNest: false || this.disabled,
        movingUuid: null,
      }
  },

  methods: {

    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },

    isOpenState (item) {
      // if(this.dragging) {
      //   return true
      // }

      if(!localStorage.getItem("icon_open_items")) {
        localStorage.setItem("icon_open_items", JSON.stringify([]));
      }
      var openedItems = JSON.parse(localStorage.getItem("icon_open_items", JSON.stringify([])))

      return openedItems.includes(item.uuid)
    },

    toggleOpenState (item, index) {
      var openedItems = JSON.parse(localStorage.getItem("icon_open_items"))

      if(openedItems.includes(item.uuid)) {
        localStorage.setItem("icon_open_items", JSON.stringify(openedItems.filter(i => i !== item.uuid)));
        // this.items[index].open = false
        this.forceRerender()
      } else {
        openedItems.push(item.uuid)
        localStorage.setItem("icon_open_items", JSON.stringify(openedItems));
        // this.items[index].open = true
        this.forceRerender()
      }
    },

    checkMove (e) {
      // console.log(e.to)
      // e.to.style.background = 'red'
      // e.item.classList.add('dragging')
    },

    itemCanHaveChildren (item) {
      return Object.values(item.external_url).filter((url) => url != null && url.length > 0).length < 1
    },

    openCreationFormNested(parent_id) {
        EventBus.$emit('setCurrentEditableItem', {
          parent_id: parent_id
        })
    },

    toggleActiveItemAtIndex (index, item_id) {
      this.items[index].active = !this.items[index].active
      this.onEnd()
    },

    setCurrentEditableItem (item) {
      item.parent_item = this.parentItem;
      EventBus.$emit('setCurrentEditableItem', item)
    },

    onStart (e) {
      if(e.item.classList.contains('restaurant')){
        EventBus.$emit('blockNest')
      } else {
        EventBus.$emit('startedDragging')
      }

      this.movingUuid = e.item.dataset.itemUuid;

    },

    onEnd (e) {
      EventBus.$emit('endedDragging')
      EventBus.$emit('orderChanged', this.movingUuid)
      this.movingUuid = null
    },
  },

  mounted () {
    EventBus.$on('startedDragging', () => this.dragging = true)
    EventBus.$on('blockNest', () => this.blockNest = true)
    EventBus.$on('endedDragging', () => {
      this.dragging = false
      this.blockNest = false
    })
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  components: {
    draggable
  },
  name: "NestedActivityContent"
};
</script>
<style>
  /*.dragging {
    opacity: .4;
    border-left: 2px solid blue;
  }*/

  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    border-left: 2px solid blue;
    opacity: 0.5;
    background: #c8ebfb;
  }

  .latest {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .latest-bulb {
    color: orange!important;
  }
  .truncated {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
